import { render } from "./AssetTypeObject.vue?vue&type=template&id=d4327a52"
import script from "./AssetTypeObject.vue?vue&type=script&lang=js"
export * from "./AssetTypeObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__